import React, { Component } from 'react'
import { Box, Container, Typography } from '@mui/material'
import HomeComponent from './HomeComponent'
import TechComponent from '../tech-stack/TechComponent';
import ServicesComponent from '../services/ServicesComponent';

import { Helmet } from 'react-helmet-async';
import AboutComponent from '../about/AboutComponent';
import ContactComponent from '../contact/ContactComponent';
import LatestPosts from '../blog/LatestPost';

class Home extends Component {
    render() {
        return (
            <Container style={{ backgroundColor: 'transparent' }} >
                <Helmet>
                    <title>Robotics Media</title>
                    <meta name="description" content="Robotics Media: Premier provider of IoT solutions, graphic design, and professional photography & videography services. Crafting innovative, customized digital experiences for businesses and corporate clients. Explore our services to elevate your brand's digital presence." />
                    <meta name="keywords" content="Robotics Media, IT solutions, graphic design, photography, videography, digital services, brand, innovate, impress, branding, bristol, kingswood, england, romania, galati" />
                </Helmet>
                <Box style={{ height: '150px' }} />
                <HomeComponent />
                <Box style={{ height: '150px' }} />
                <AboutComponent />
                <Box style={{ height: '150px' }} />
                <ServicesComponent />
                <Box style={{ height: '80px' }} />
                <Box sx={{ width: '100%', px: { xs: 2, md: 6 } }}>
                    <Typography variant="h4" color="white" sx={{ fontFamily: 'PT Mono, monospace' }}>
                        Who We Work With
                    </Typography>
                    <Box sx={{ height: '12px' }} />
                    <Typography color="rgba(255,255,255,0.9)" sx={{ maxWidth: '900px', fontFamily: 'Work Sans, sans-serif' }}>
                        We partner with founders, growing teams, and established businesses who need clear systems and reliable delivery. If you run a retail space, hospitality venue, office, school, or manufacturing site, we can support your next move.
                    </Typography>
                    <Box sx={{ height: '16px' }} />
                    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                        {['Startups', 'SMEs', 'Retail', 'Hospitality', 'Corporate', 'Education', 'Manufacturing'].map((label) => (
                            <Box key={label} sx={{ px: 2, py: 0.75, borderRadius: '999px', border: '1px solid rgba(255,255,255,0.35)', color: 'white', fontFamily: 'PT Mono, monospace', fontSize: '0.85rem' }}>
                                {label}
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Box style={{ height: '150px' }} />
                <TechComponent />
                <Box style={{ height: '150px' }} />
                <LatestPosts />
                <Box style={{ height: '150px' }} />
                <ContactComponent />
                <Box style={{ height: '50px' }} />
            </Container>
        )
    }
}

export default Home;
